var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { styled, css } from '@creditas-ui/system';
import { ifProp, compose, background, border, color, flexbox, grid, layout, position, shadow, space, typography } from '@creditas-ui/utilities';
var Box = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n\n  ", "\n"])), compose(background, border, color, flexbox, grid, layout, position, shadow, space, typography), ifProp('spaceY', function (_ref) {
  var spaceY = _ref.spaceY;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      & > :not([hidden]) ~ :not([hidden]) {\n        margin-top: ", ";\n      }\n    "])), spaceY);
}), ifProp('spaceX', function (_ref2) {
  var spaceX = _ref2.spaceX;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      & > :not([hidden]) ~ :not([hidden]) {\n        margin-left: ", ";\n      }\n    "])), spaceX);
}));
export { Box };